/**
 * Ground pebbles matching the PixelSkeetScene: 2x1 pixel blocks (scale 3 on
 * desktop, 2 on mobile) in brown at 25% opacity, spaced every 34px with jitter.
 */
function buildTile(scale: number, color: string, opacity: number) {
  const step = 34;
  const count = 10;
  const width = step * count; // seamless repeat
  const height = 18;
  const pw = 2 * scale;
  const ph = 1 * scale;

  let seed = 1337;
  const rnd = () => ((seed = (seed * 1103515245 + 12345) % 2147483648) / 2147483648);

  let rects = "";
  for (let i = 0; i < count; i++) {
    const x = Math.round(6 + i * step + rnd() * 22);
    const y = Math.round(2 + rnd() * 12);
    rects += `<rect x="${x}" y="${y}" width="${pw}" height="${ph}"/>`;
  }

  const svg =
    `<svg xmlns="http://www.w3.org/2000/svg" width="${width}" height="${height}" viewBox="0 0 ${width} ${height}" shape-rendering="crispEdges">` +
    `<g fill="${color}" opacity="${opacity}">${rects}</g>` +
    `</svg>`;

  return { url: encodeURIComponent(svg), width, height };
}

export function PebbleGround({ color = "#2A1510", opacity = 0.25 }: { color?: string; opacity?: number }) {
  const desktop = buildTile(3, color, opacity);
  const mobile = buildTile(2, color, opacity);

  return (
    <>
      <div
        className="pointer-events-none mt-5 w-full sm:hidden"
        style={{
          height: mobile.height,
          backgroundImage: `url("data:image/svg+xml,${mobile.url}")`,
          backgroundRepeat: "repeat-x",
          backgroundSize: `${mobile.width}px ${mobile.height}px`,
        }}
        aria-hidden="true"
      />
      <div
        className="pointer-events-none mt-5 hidden w-full sm:block"
        style={{
          height: desktop.height,
          backgroundImage: `url("data:image/svg+xml,${desktop.url}")`,
          backgroundRepeat: "repeat-x",
          backgroundSize: `${desktop.width}px ${desktop.height}px`,
        }}
        aria-hidden="true"
      />
    </>
  );
}
